import { Reducer } from 'redux'

import { FacebookPartnerActionTypes, FBModalReducerName, IFacebookPartnerState } from './types'

import { IAdAccount } from '@/store/adaccounts/types'

export const initialState: IFacebookPartnerState = {
  profile: {
    picture: '',
    name: '',
    is_valid: false,
    is_authorized: false,
    is_loading: true,
    errorMessage: '',
  },
  sentFormInfo: {
    isSent: false,
    facebook_business_pages: [],
    business_manager_id: '',
  },
  applications: [],
  selectedWorkflow: null,
  modals: null,
}

const reducer: Reducer<IFacebookPartnerState> = (state = initialState, action: any) => {
  switch (action.type) {
    case FacebookPartnerActionTypes.SET_FACEBOOK_PROFILE: {
      return {
        ...state,
        profile: {
          ...state.profile,
          errorMessage: '',
          ...action.data,
        },
      }
    }
    case FacebookPartnerActionTypes.SET_APPLICATIONS_SENT: {
      return {
        ...state,
        sentFormInfo: action.data,
      }
    }
    case FacebookPartnerActionTypes.SET_APPLICATIONS_LOADING: {
      return {
        ...state,
        isFormLoading: action.data,
      }
    }
    case FacebookPartnerActionTypes.SET_SELECTED_WORKFLOW: {
      return {
        ...state,
        selectedWorkflow: action.data,
      }
    }
    case FacebookPartnerActionTypes.SET_APPLICATIONS: {
      return {
        ...state,
        applications: action.data,
      }
    }
    case FacebookPartnerActionTypes.CLOSE_APPLICATION: {
      const index = state.applications.findIndex((account: IAdAccount) => account.id === action.data.id)
      const applications = [...state.applications.slice(0, index), ...state.applications.slice(index + 1)]

      return {
        ...state,
        applications,
      }
    }
    case `${FBModalReducerName}.OPEN_MODAL`: {
      return {
        ...state,
        modals: action.payload,
      }
    }
    case `${FBModalReducerName}.CLOSE_MODAL`: {
      return {
        ...state,
        modals: null,
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as facebookPartnerReducer }
